export enum PageRoutes {
  CALENDAR_PAGE = "/",
  PROFILE_PAGE = "/personalInfo",
  MEETING_PLANNER_PAGE = "/meetingPlaner",
  FILTERED_MEETINGS_PAGE = '/filteredMeetings',
  LOGIN = "/login",
  EMAIL_CONFIRMATION = '/emailConfirmation',
  MEETING_CONFIRMATION = '/meetingConfirmation',
  OUTER_MEETING_CONFIRMATION = '/outerConfirmation',
  CONFIRMATION = '/emailConfirmation',
  ONBOARDING = '/onboarding/:calendarUrl?',
  PUSH_PAGE ='/push',
  EMPLOYEES_PAGE = '/employees',
}

export enum ProfileRoutes {
  CONNECTED_CALENDARS_TAB = 'calendars',
  NOTIFICATIONS_TAB = 'notification',
}
